import { apiRequest, apiSecureRequest } from '@utils/request';
import {
	HelpCenterArticle,
	HelpCenterCategory,
	HelpCenterSearchQuery,
	HelpCenterSection,
	HelpCenterVote
} from 'types/help-center';
import { AxiosResponse } from 'axios';

export const getHelpCenterCategories = async (): Promise<Array<HelpCenterCategory>> => {
	const response = await apiRequest.get(`/zendesk/help-center`);
	return response.data;
};

export const getHelpCenterCategory = async (categoryId: string): Promise<HelpCenterCategory> => {
	const response = await apiRequest.get(`/zendesk/help-center/categories/${categoryId}`);
	return response.data;
};

export const getHelpCenterSection = async (sectionId: string): Promise<HelpCenterSection> => {
	const response = await apiRequest.get(`/zendesk/help-center/sections/${sectionId}`);
	return response.data;
};

export const getHelpCenterArticle = async (articleId: string): Promise<HelpCenterArticle> => {
	const response = await apiRequest.get(`/zendesk/help-center/articles/${articleId}`, {
		suppressToast: (resp: AxiosResponse) => resp.status === 404
	});
	return response.data;
};

export const getHelpCenterVote = async (articleId: string): Promise<HelpCenterVote> => {
	const response = await apiSecureRequest.get(`/zendesk/help-center/articles/${articleId}/vote-data`);
	response.data.value = 0;
	return response.data;
};

export const postHelpCenterVote = async (vote: HelpCenterVote): Promise<void> => {
	await apiSecureRequest.post(`/zendesk/help-center/vote`, vote);
};

export const searchHelpCenterArticles = async (
	searchQuery: HelpCenterSearchQuery
): Promise<Array<HelpCenterArticle>> => {
	const response = await apiRequest.post(`/zendesk/help-center/search`, searchQuery);
	return response.data;
};
